module.exports = __webpack_public_path__ + "static/media/game-icon-v2.2c6f188a.png";